<template>
	<div class="container">
		页面跳转中，请稍侯...
	</div>
</template>


<script>
	import {
		mixin
	} from '@/utils/mixin.js'
	export default {
		name: 'CN_MailTo',
		mixins: [mixin],
		data() {
			return {
				language: 'cn', 	//语言版本
				orderNo: ''
			}
		},
		mounted() {
		},
		created() {
			this.orderNo = this.$route.query.OrderNo
			
			if(this.isMobile())
			{
				//手机
				window.location.href = 'http://m.hawaiiglobalholiday.com/pages/' + this.language + '/user/order_detail?OrderNo=' + this.orderNo
			}
			else
			{
				//电脑
				window.location.href = '/' + this.language + '/user/order_detail?OrderNo=' + this.orderNo
			}
		},
		methods: {
		},
	}
</script>

<style lang="less" scoped>
	@import url("../../assets/css/global.css");
	body {
		font-size: 13px;
	}
	.container {		
		width: 100vw;
		height: 100vh;
		text-align: center;
		line-height: 100vh;
	}
</style>